import {
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
} from "@mui/material";
import datetimeHelper from "helper/datetime-helper";

const TableRowTotal = ({ data, columns, showBorder }) => {
  const totalColIndex = columns.findIndex((col) => col.totalType);

  return (
    <>
      {totalColIndex !== -1 && data?.length > 0 && (
        <MuiTableRow>
          {columns.map((col, index) => {
            if (!col.totalType && index === 0)
              return (
                <MuiTableCell
                  colSpan={totalColIndex}
                  align="center"
                  key={col.id}
                  sx={{
                    ...(showBorder && {
                      border: "1px solid rgba(224, 224, 224, 1)",
                    }),
                  }}>
                  Tổng cộng
                </MuiTableCell>
              );
            if (!col.totalType) return null;

            let value;
            if (col.totalType === "sum") {
              value = data.reduce(
                (result, record) => result + record[col.id],
                0
              );
            }
            if (col.totalType === "avg") {
              value =
                data.reduce((result, record) => result + record[col.id], 0) /
                data.length;
            }
            if (col.type === "timeSeconds")
              value = value ? datetimeHelper.secondToHHMMSS(value) : "00:00:00";
            if (col.type === "timeMilliseconds")
              value = value ? datetimeHelper.msToHHMMSS(value) : "00:00:00";

            return (
              <MuiTableCell
                key={col.id}
                align={col.align}
                sx={{
                  ...(showBorder && {
                    border: "1px solid rgba(224, 224, 224, 1)",
                  }),
                }}>
                {value}
              </MuiTableCell>
            );
          })}
        </MuiTableRow>
      )}
    </>
  );
};

export default TableRowTotal;
